import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import companiesImage from '../../../../assets/images/markets/other/globalcompanies/main.jpg';
import './GlobalCompanies.css';

const GlobalCompanies = ({ title, paragraphs, image }) => {
  if (!title || !paragraphs?.length) {
    return null;
  }

  return (
    <section className="market-global-companies">
      <div className="market-global-companies__inner">
        <Reveal className="market-global-companies__copy">
          <h2 className="market-global-companies__title">{title}</h2>
          {paragraphs.map((paragraph) => (
            <p key={paragraph} className="market-global-companies__text">
              {paragraph}
            </p>
          ))}
        </Reveal>

        <Reveal className="market-global-companies__media" delay={80}>
          <img
            className="market-global-companies__image"
            src={image || companiesImage}
            alt=""
            aria-hidden="true"
          />
        </Reveal>
      </div>
    </section>
  );
};

export default GlobalCompanies;
